import type { WithT } from "i18next";

export const InputCstics = {
  TotalLength: "totalLength",
  aL: "aL",
  aR: "aR",
  partSizingType: "partSizingType",
  partAmount: "partAmount",
  partOne: "partOne",
  partTwo: "partTwo",
  partThree: "partThree",
  partFour: "partFour",
  partFive: "partFive",
};

export const HelperCstics = {
  totalLengthMin: "totalLengthMin",
  totalLengthMax: "totalLengthMax",
  alRecommendedMin: "alRecommendedMin",
  alRecommendedMax: "alRecommendedMax",
  alHardMax: "alHardMax",
  arRecommendedMin: "arRecommendedMin",
  arRecommendedMax: "arRecommendedMax",
  arHardMax: "arHardMax",
};

export const ExtraConfig = {
  AlarHelperTextFactory: "alarHelperTextFactory",
  showNotRecommendedWarning: "showNotRecommendedWarning",
};

export interface AlarHelperTextFactoryParams {
  hardMin?: number;
  hardMax?: number;
  recommendedMin?: number;
  recommendedMax?: number;
  value: number | null;
  t: WithT["t"];
}

export type AlarHelperTextFactory = (params: AlarHelperTextFactoryParams) => string;
